/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Title,
  GoBack,
  Message,
  InputField,
  ActionButton,
} from "../../component/Component";
import {
  codeOk,
  codeCreate,
  errorMessage,
} from "../../../../middlewares/index";
import EventsList from "./EventsList";
import AttractionsList from "./AttractionsList";
import { usePageContext } from "../../../../context/page/PageContext";
import { getOnePage } from "../../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../../middlewares/breadCrumb/BreadCrumbComponent";
import { createPortal } from "react-dom";
import {
  FiEdit3,
  FiLayers,
  FiCalendar,
  FiMapPin,
  FiTrash2,
  FiX,
  FiCheck,
  FiInfo,
  FiTag,
} from "react-icons/fi";

const Edit = () => {
  const memory = getOnePage();
  const { updatePage } = usePageContext();
  const [category, setCategory] = useState(memory.category);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(1);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setErrorMessage] = useState(null);
  const [menu, setMenu] = useState("event");
  const [pages, setPages] = useState([]);
  const [confirmSave, setConfirmSave] = useState(false);
  const [confirmRemove, setConfirmRemove] = useState({ open: false, slug: null, title: "" });
  const pageRoutes = "/page";

  useEffect(() => {
    setPages(
      ...memory.localPages.map((content) =>
        content.filter((val) => val.category === memory.category)
      )
    );
  }, []);

  const cleanFields = () => {
    setSuccess(true);
    setLoading(false);
    setCategory(null);
  };

  const responses = (isError, st, msg) => {
    setError(isError);
    setStatus(st);
    setErrorMessage(msg);
  };

  const requestSubmit = (e) => {
    e.preventDefault();
    setConfirmSave(true);
  };

  const performSubmit = async () => {
    setLoading(true);
    if (!category) {
      setLoading(false);
      return responses(true, 400, "Page Title is Required");
    }
    if (pages.length === 0) {
      setLoading(false);
      return responses(true, 400, "Add Content To Page");
    }
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const filter = pages.map((val) => {
      return {
        description: val.description,
        hashtag: val.hashtag,
        image_cdn_id: val.image_cdn_id,
        slug: val.slug,
        status: val.status,
        thumbnail: val.thumbnail,
        title: val.title,
      };
    });
    const data = {
      category: category,
      old_category: memory.category,
      data: filter,
    };

    const response = await updatePage(data);
    if (response) {
      if (
        response.data.status === codeOk ||
        response.data.status === codeCreate
      ) {
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: pageRoutes }} />

      <form onSubmit={requestSubmit}>
        <div className="mx-auto max-w-6xl">
          <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
            <div className="flex flex-col gap-2 px-5 pt-5 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                  <FiEdit3 className="h-5 w-5" />
                </span>
                <div>
                  <Title props={{ title: "Edit Page" }} />
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs">
                    <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                      <FiTag className="h-3.5 w-3.5" />
                      Current category: {memory.category}
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                      <FiLayers className="h-3.5 w-3.5" />
                      {pages.length} items selected
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-5 pb-5">
              <div className="mt-4">
                <Message
                  props={{
                    error,
                    success,
                    message,
                    loading,
                    status,
                    onClick: () => {
                      setError(false);
                      setSuccess(false);
                      setErrorMessage("");
                    },
                  }}
                />
              </div>

              <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2">
                <div className="space-y-6">
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <label htmlFor="page" className="text-[13px] font-semibold text-gray-800">
                        Page Title
                      </label>
                      <span className="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                        <FiInfo className="h-3 w-3" />
                        Required
                      </span>
                    </div>
                    <InputField
                      props={{
                        id: "page",
                        title: "Page Title",
                        type: "text",
                        required: true,
                        value: category ? category : "",
                        onChange: (e) => {
                          setCategory(e.target.value);
                          setError(null);
                          setSuccess(null);
                        },
                      }}
                    />
                  </div>

                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <Title props={{ title: "Page Content" }} />
                      <span className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 px-2 py-[2px] text-[10px] font-semibold text-gray-700">
                        <FiLayers className="h-3 w-3" />
                        {pages.length} items
                      </span>
                    </div>

                    <div className="rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
                      {pages.length === 0 ? (
                        <div className="text-xs font-medium text-gray-600">
                          This page has no content. Use the selectors on the right to add items.
                        </div>
                      ) : (
                        <ul className="space-y-3">
                          {pages.map((value, index) => (
                            <PageContent
                              slug={value.slug}
                              index={index}
                              title={value.title}
                              key={`${value.slug}-${index}`}
                              setPages={setPages}
                              pages={pages}
                              onAskRemove={(slug, title) => setConfirmRemove({ open: true, slug, title })}
                            />
                          ))}
                        </ul>
                      )}
                    </div>

                    <div className="w-full">
                      <ActionButton
                        props={{
                          title: "Save Changes",
                          error,
                          success,
                          message,
                          loading,
                          status,
                          onClick: () => {
                            setError(false);
                            setSuccess(false);
                            setErrorMessage("");
                            setConfirmSave(true);
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="rounded-2xl border border-gray-200 bg-white/90 p-2 shadow-sm">
                    <div className="flex w-full justify-start gap-3 text-sm font-semibold">
                      <button
                        type="button"
                        onClick={() => setMenu("event")}
                        className={[
                          "inline-flex items-center gap-2 rounded-xl px-4 py-2 transition",
                          menu === "event"
                            ? "bg-gray-900 text-white"
                            : "bg-gray-100 text-gray-800 hover:bg-gray-200",
                        ].join(" ")}
                      >
                        <FiCalendar className="h-4 w-4" />
                        Events List
                      </button>
                      <button
                        type="button"
                        onClick={() => setMenu("attraction")}
                        className={[
                          "inline-flex items-center gap-2 rounded-xl px-4 py-2 transition",
                          menu === "attraction"
                            ? "bg-gray-900 text-white"
                            : "bg-gray-100 text-gray-800 hover:bg-gray-200",
                        ].join(" ")}
                      >
                        <FiMapPin className="h-4 w-4" />
                        Attractions List
                      </button>
                    </div>

                    <div className="mt-4">
                      {menu === "event" ? (
                        <EventsList setPages={setPages} pages={pages} />
                      ) : (
                        <AttractionsList setPages={setPages} pages={pages} />
                      )}
                    </div>

                    <div className="mt-3 flex items-center gap-2 text-[11px] text-gray-600">
                      <FiInfo className="h-3.5 w-3.5" />
                      Use “Add” on an item to include it, or “Remove” to exclude.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <ConfirmModal
        open={confirmSave}
        title="Save changes to this page?"
        description="Your updates will be applied to the selected category."
        onCancel={() => setConfirmSave(false)}
        onConfirm={() => {
          setConfirmSave(false);
          performSubmit();
        }}
        confirmText="Save"
      />

      <ConfirmModal
        open={confirmRemove.open}
        title="Remove content from page?"
        description={`This will remove “${confirmRemove.title}” from the current page.`}
        onCancel={() => setConfirmRemove({ open: false, slug: null, title: "" })}
        onConfirm={() => {
          setPages(pages.filter((val) => val.slug !== confirmRemove.slug));
          setConfirmRemove({ open: false, slug: null, title: "" });
        }}
        confirmText="Remove"
        tone="danger"
      />
    </div>
  );
};

export default Edit;

const PageContent = ({ index, title, slug, setPages, pages, onAskRemove }) => {
  return (
    <li className="rounded-xl border border-gray-200 bg-white p-3 shadow-sm">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-12 md:items-center">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-[10px] font-bold text-white">
              {String(title).slice(0, 2).toUpperCase()}
            </span>
            <div className="min-w-0">
              <div className="truncate text-sm font-semibold text-gray-900">
                {index + 1}. {title}
              </div>
              <div className="truncate text-[11px] text-gray-500">{slug}</div>
            </div>
          </div>
        </div>
        <div className="md:col-span-5 md:justify-self-end">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => onAskRemove(slug, title)}
              className="inline-flex items-center gap-2 rounded-lg bg-red-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
            >
              <FiTrash2 className="h-4 w-4" />
              Remove
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

const ConfirmModal = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = "Proceed",
  tone = "primary",
}) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl" />
        <div className="relative px-5 pt-5">
          <div className="flex items-start gap-3">
            <span
              className={[
                "grid h-9 w-9 place-items-center rounded-lg",
                tone === "danger" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700",
              ].join(" ")}
            >
              {tone === "danger" ? <FiTrash2 className="h-5 w-5" /> : <FiInfo className="h-5 w-5" />}
            </span>
            <div>
              <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
                {title}
              </h3>
              {description ? (
                <p id="confirm-desc" className="mt-1 text-sm text-gray-600">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={[
              "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-xs font-semibold text-white shadow focus:outline-none focus-visible:ring-2",
              tone === "danger"
                ? "bg-red-600 hover:bg-red-700 focus-visible:ring-red-500"
                : "bg-gray-900 hover:bg-black focus-visible:ring-emerald-500",
            ].join(" ")}
          >
            <FiCheck className="h-4 w-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
